import CustomSearch from '../components/CustomSearch'
import { useCallback, useEffect, useState } from 'react'
import CustomSelection from '../components/CustomSelection'
import Menu from '../components/Menu'
import filterIcon from '../assets/new-ui/marketplace/filter-icon.png';
import arrowRight from '../assets/new-ui/arrow-right.png';
import arrowLeft from '../assets/new-ui/arrow-left.png';
import arrowDown from '../assets/new-ui/arrow-light-down.png'
import arrowUp from '../assets/new-ui/arrow-light-up.png'
import arrowDownBig from '../assets/new-ui/arrow-down.png'
import tickLine from '../assets/new-ui/marketplace/tick-line.png'
import tickSquare from '../assets/new-ui/marketplace/tick-square.png'
// import { sharkList } from '../services/data'
import ItemSell from '../components/ItemSell'
import CustomOption from '../components/CustomOption'
import { STATUS_ALL, statusFilterList, collectionFilterList, rarityFilterList, priceFilterList, BNB_UNIT, BNB_DECIMAL, sortType, RARITY_ALL } from '../constants/config'
import CustomInput from '../components/CustomInput'
import CustomInputRange from '../components/CustomInputRange'
import ScrollTop from "../components/ScrollTop";
import { checkExpireToken, getAllLikeNFT, getAllNFT, likeNFT, searchNFT, unlikeNFT } from '../services/api'
import { convertBNBPrice, formatBalanceDisplay, isMobile } from '../utils/utils'
import { useHistory } from "react-router-dom"
import { sortAll, sortIdDescrease, sortIdIncrease, sortPriceDescrease, sortPriceIncrease, sortRarityDescrease, sortRarityIncrease } from '../utils/sortBy'
import ConnectWallet from '../components/ConnectWallet';
import ModalRequiredLogin from '../components/ModalRequiredLogin';
import { useAddress, useNetwork } from '../contexts/Context';
import { clearLocalData, getLocalData } from '../services/localData';
import Loading from '../components/Loading';
import { debounce } from 'lodash';
import Bubble from "../components/coral/Bubble";
import CoralLeftType2 from "../components/coral/CoralLeftType2";
import CoralRightType2 from "../components/coral/CoralRightType2";

export default function Marketplace() {
  const [listNFT, setListNFT] = useState([])
  // const [listNFTLiked, setListNFTLiked] = useState([])

  const sortByList = [sortType.all, sortType.priceInc, sortType.priceDes, sortType.idInc, sortType.idDes, sortType.rarityInc, sortType.rarityDes]
  const history = useHistory()
  const [ethAddress, setAddress] = useAddress()
  const [, setNetwork] = useNetwork()

  const [searching, setSearching] = useState('')
  const [sortBy, setSortBy] = useState(null)
  const [viewLarge, setViewLarge] = useState(true)
  const [filterShow, setFilterShow] = useState(true)
  const [statusFilterShow, setStatusFilterShow] = useState(true)
  const [priceFilterShow, setPriceFilterShow] = useState(true)
  const [collectionFilterShow, setCollectionFilterShow] = useState(true)
  const [rarityFilterShow, setRarityFilterShow] = useState(true)

  // Filter tools value
  const [dayFilter, setDayFilter] = useState('31')
  const [statusFilter, setStatusFilter] = useState(STATUS_ALL)
  const [priceUnitFilter, setPriceUnitFilter] = useState(BNB_UNIT)
  const [priceMinFilter, setPriceMinFilter] = useState(null)
  const [priceMaxFilter, setPriceMaxFilter] = useState(null)
  const [collectionFilter, setCollectionFilter] = useState(null)
  const [rarityFilter, setRarityFilter] = useState(null)
  const [favoriteFilter, setFavoriteFilter] = useState(false)
  
  const [requireLoginBox, setRequireLoginBox] = useState(false)
  const [, setToggle] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!isMobile()) setFilterShow(true)
    else setFilterShow(false)

    getAllNFTList()
  },[])

  useEffect(() => {
    if (ethAddress && listNFT.length > 0) {
      // console.log('vao day')
      const accessToken = getLocalData('accessToken')
      const tokenIdList = listNFT.map(item => item.id)
      getAllLikeNFTList(accessToken,tokenIdList)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[ethAddress,listNFT])

  useEffect(() => {
    if (favoriteFilter) {
      const favoriteList = listNFT.filter(item => item.isLiked)
      setListNFT(favoriteList)
    }
    else {
      getAllNFTList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[favoriteFilter])

  useEffect(() => {
    filterNFT(statusFilter,dayFilter,priceMinFilter,priceMaxFilter,rarityFilter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[statusFilter,dayFilter,priceUnitFilter,priceMinFilter,priceMaxFilter,collectionFilter,rarityFilter])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const filterNFT = useCallback(debounce((status,day,priceMin,priceMax,rarity) => {
    // console.log(priceMin)
    // setLoading(true)
    const timeLimit = handleFilterDay(day)
    getAllNFT(
      status === STATUS_ALL ? null : status,
      timeLimit.list_time_gte, //dayFilter
      timeLimit.list_time_lte, 
      null, //priceUnitFilter
      priceMin ? convertBNBPrice(priceMin) : null,
      priceMax ? convertBNBPrice(priceMax) : null,
      null, //collectionFilter
      rarity === RARITY_ALL ? null : rarity
    ).then(result => {
      // setLoading(false)
      // console.log(result)
      if (result.success) {
        setListNFT(result.message.items)
      }
    })
  },500),[])

  useEffect(() => {
    if (searching && searching !== '') {
      findNFT(searching)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[searching])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const findNFT = useCallback(debounce((query) => {
    searchNFT(query).then(result => {
      setListNFT(result.message.items)
    })
  },1000),[])

  useEffect(() => {
    if (listNFT.length > 0 && sortBy) {
      handleSortBy(sortBy)
      setListNFT(listNFT)
      setToggle(old => !old)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[listNFT, sortBy])

  function getAllNFTList() {
    getAllNFT().then(result => {
      // console.log(result)
      if (result.success) {
        setListNFT(result.message.items)
      }
    })
  }

  function getAllLikeNFTList(accessToken,tokenIdList) {
    getAllLikeNFT(accessToken,tokenIdList).then(result => {
      if (result.success) {
        // console.log(result.message)
        likedMapping(result.message)
        // setListNFTLiked(result.message)
      }
    })
  }

  // function checkNFTLiked(id) {
  //   for (let i=0;i<listNFTLiked.length;i++) {
  //     if (id === listNFTLiked[i].id) return true
  //   }
  //   return false
  // }

  function likedMapping(likedList) {
    likedList.forEach(item => {
      listNFT.forEach(nft => {
        if (nft.id === item.id) {
          nft.isLiked = true
        }
      })
    })
    // console.log(listNFT)
    setToggle(old => !old)
  }

  function handleSortBy(sortBy) {
    switch (sortBy) {
      case sortType.all:
        sortAll(listNFT)
        break;
      case sortType.priceInc:
        sortPriceIncrease(listNFT)
        break;
      case sortType.priceDes:
        sortPriceDescrease(listNFT)
        break;
      case sortType.idInc:
        sortIdIncrease(listNFT)
        break;
      case sortType.idDes:
        sortIdDescrease(listNFT)
        break;
      case sortType.rarityInc:
        sortRarityIncrease(listNFT)
        break;
      case sortType.rarityDes:
        sortRarityDescrease(listNFT)
        break;
      default:
        sortAll(listNFT)
        break;
    }
  }

  function handleFilterDay(number) {
    const dayCurrent = new Date().getTime()
    if (number === 0) {
      const dayPast = dayCurrent - 24 * 60 * 60 * 1000 + 1
      return {
        list_time_lte: new Date(dayCurrent).toISOString(),
        list_time_gte: new Date(dayPast).toISOString()
      }
    }
    else if (number === 31) {
      return {
        list_time_lte: null,
        list_time_gte: null
      }
    }
    else {
      const dayPast = dayCurrent - number * 24 * 60 * 60 * 1000
      return {
        list_time_lte: new Date(dayCurrent).toISOString(),
        list_time_gte: new Date(dayPast).toISOString()
      }
    }
  }

  function handleLikeNFT(nftId, liked, index) {
    // console.log(nftId)
    // console.log(liked)
    //check address, token expire, liked
    if (ethAddress) {
      const token = getLocalData('accessToken')
      checkExpireToken(token).then(async result => {
        if (result.success) {
          if (!liked) {
            await likeNFT(nftId,token)
            listNFT[index].isLiked = true
            listNFT[index].likeCount++
            setToggle(old => !old)
            // getAllNFTList()
          }
          else {
            await unlikeNFT(nftId,token)
            listNFT[index].isLiked = false
            listNFT[index].likeCount--
            setToggle(old => !old)
            // getAllNFTList()
          }
        }
        else {
          sessionExpired()
        }
      })
    }
    else setRequireLoginBox(true)
  }

  function sessionExpired() {
    clearLocalData()
    setAddress(null)
    setNetwork(null)
  }

  return (
    <div className='pageContainer marketplaceContainer'>
      <Menu />
      <ScrollTop />
      <ConnectWallet />
      <Loading loading={loading} />
      <CoralLeftType2 />
      <CoralRightType2 />
      <Bubble top={'200px'} />
      
      <ModalRequiredLogin 
        toggleModal={requireLoginBox}
        setToggleModal={setRequireLoginBox}
      />
      <div className='detailTitle'>MARKETPLACE</div>
      <div className='searchArea'>
        <CustomSearch 
          placeholder='Search items, collections, and accounts'
          searching={setSearching}
        />
      </div>

      <div className='marketplaceContent'>
        <div className={filterShow ? 'marketplaceFilter' : 'marketplaceFilterHidden'}>
          <div className='filterHeader'>
            <div className='filterTitle'>
              <img src={filterIcon} alt='' />
              <div>Filter</div>
            </div>
            <img src={filterShow ? arrowLeft : arrowRight} alt='' className='toggleFilter' onClick={() => setFilterShow(old => !old)}/>
          </div>
          <div className='filterOption'>
            <div className='filterOptionTitle'>
              <div>Number of days since listed</div>
            </div>
            <div className={'filterOptionTool'} style={{marginTop: '40px'}}>
                <CustomInputRange 
                  min={0}
                  max={31}
                  value={dayFilter}
                  setValue={setDayFilter}
                />
                <div className='dayFilterDescription'>Range 0-30</div>
            </div>
          </div>

          <div className='filterOption'>
            <div className='filterOptionTitle' onClick={() => setStatusFilterShow(old => !old)}>
              <div>Status</div>
              <img src={statusFilterShow ? arrowUp : arrowDown} alt=''/>
            </div>
            <div className={statusFilterShow ? 'filterOptionTool' : 'filterOptionToolHidden'}>
              <CustomOption 
                list={statusFilterList}
                currentOption={statusFilter}
                setCurrentOption={setStatusFilter}
              />
            </div>
          </div>

          <div className='filterOption' style={{zIndex: 3}}>
            <div className='filterOptionTitle' onClick={() => setPriceFilterShow(old => !old)}>
              <div>Price</div>
              <img src={priceFilterShow ? arrowUp : arrowDown} alt=''/>
            </div>
            <div className={priceFilterShow ? 'filterOptionTool' : 'filterOptionToolHidden'}>
              <CustomSelection 
                list={priceFilterList}
                setCurrent={setPriceUnitFilter}
                innerWidth={288}
                customArrow={arrowDownBig}
              />
              <div className='priceRanked'>
                <CustomInput 
                  placeholder={'Min'}
                  value={priceMinFilter}
                  setValue={setPriceMinFilter}
                  innerWidth={95}
                  type={'number'}
                />
                <div>to</div>
                <CustomInput 
                  placeholder={'Max'}
                  value={priceMaxFilter}
                  setValue={setPriceMaxFilter}
                  innerWidth={95}
                  type={'number'}
                />
              </div>
            </div>
          </div>

          <div className='filterOption' style={{zIndex: 2}}>
            <div className='filterOptionTitle' onClick={() => setCollectionFilterShow(old => !old)}>
              <div>Collections</div>
              <img src={collectionFilterShow ? arrowUp : arrowDown} alt=''/>
            </div>
            <div className={collectionFilterShow ? 'filterOptionTool' : 'filterOptionToolHidden'}>
              <CustomSelection 
                list={collectionFilterList}
                setCurrent={setCollectionFilter}
                innerWidth={288}
                customArrow={arrowDownBig}
              />
            </div>
          </div>

          <div className='filterOption'>
            <div className='filterOptionTitle' onClick={() => setRarityFilterShow(old => !old)}>
              <div>Rarity</div>
              <img src={rarityFilterShow ? arrowUp : arrowDown} alt=''/>
            </div>
            <div className={rarityFilterShow ? 'filterOptionTool' : 'filterOptionToolHidden'}>
              <CustomSelection 
                list={rarityFilterList}
                setCurrent={setRarityFilter}
                innerWidth={288}
                customArrow={arrowDownBig}
              />
            </div>
          </div>
          
          <div className='filterOption'>
            <div className='filterOptionTitle' onClick={() => ethAddress ? setFavoriteFilter(old => !old) : setRequireLoginBox(true)} style={{position: 'relative'}}>
              <div>My favorites</div>
              <img className='tickSquare' src={tickSquare} alt='tick square' />
              <img className={favoriteFilter ? 'tickLine' : 'tickLine tickLineHidden'} src={tickLine} alt='tick line' />
            </div>
          </div>
        </div>

        <div className='marketplaceNFTs'>
          {
            !isMobile()
              ? <div className='toolsRow'>
                  <div className='numberResult'>{listNFT.length} {listNFT.length > 1 ? 'results' : 'result'}</div>
                  <div className='toolGroup'>
                    <CustomSelection 
                      list={sortByList}
                      setCurrent={setSortBy}
                      title='Sort By'
                      innerWidth={204}
                    />
                    {/* <div className='seeAllBtn'>See all NFTs</div> */}
                    <div className='viewGroup'>
                      <div className='viewLarge' onClick={() => setViewLarge(true)}>
                        <div className={viewLarge ? 'viewLargeActive' : 'viewLargeDisable'} />
                      </div>
                      <div className='viewSmall' onClick={() => setViewLarge(false)}>
                        <div className={!viewLarge ? 'viewSmallActive' : 'viewSmallDisable'} />
                      </div>
                    </div>
                  </div>
                </div>
              : <div className='toolsRow'>
                  <div className='filterMobile' onClick={() => setFilterShow(old => !old)}>
                    <div className='filterMobileLeft'>
                      <img src={filterIcon} alt='' />
                      <div>Filter</div>
                    </div>
                    <img src={arrowDown} alt='arrow' />
                  </div>
                  <div className='toolGroup sortByMobile'>
                    <CustomSelection 
                      list={sortByList}
                      setCurrent={setSortBy}
                      title='Sort By'
                      innerWidth={59}
                      boxWidth={172}
                    />
                  </div>
                </div>
          }
          
          {
            !isMobile()
              ? ''
              : <div className='toolsRow' style={{justifyContent:'center', marginTop: '20px'}}>
                  <div className='numberResult'>{listNFT.length} {listNFT.length > 1 ? 'results' : 'result'}</div>
                </div>
          }
          <div className='itemContainer'>
            <div className={viewLarge ? 'itemList nftLarge' : 'itemList nftSmall'}>
              {
                listNFT.map((item,index) => {
                  return (
                    <ItemSell
                      key={index} 
                      image={item.nft.imageUrl}
                      id={item.nft.name} 
                      rarityPoint={item.nft.point}
                      rarityClass={item.nft.rare}
                      price={formatBalanceDisplay(item.currentPrice/ BNB_DECIMAL)}
                      unit={item.currentCurrency}
                      likeNumber={item.likeCount}
                      timestamp={item.updatedAt}
                      isLiked={item.isLiked}
                      fn={() => history.push('/detail/' + item.nft.tokenId)}
                      likeFn={() => handleLikeNFT(item.id,item.isLiked,index)}
                    />
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
      
    </div>
  )
}